// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"29b8d740","183":"883c13f4","356":"0e135894","496":"e9a43956","513":"cdc28887","590":"73565130","626":"0fc9f459","937":"5ce78efb","985":"f8efb888"}[chunkId] + ".chunk.js";
};